<template>
  <div class="air-rank">
    <ComBox>
      <template #title>
        <TitleBar title="安次区乡镇空气质量排名" :icon="icon">
          <template #right>
            <TabBar :list="tabList" v-model="currentTab" @change="getData" />
          </template>
        </TitleBar>
      </template>
      <div class="table-wrapper">
        <ComTable :columns="columns" :data="tableData">
          <template #index="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
        </ComTable>
      </div>
    </ComBox>
  </div>
</template>

<script>
  import TitleBar from "../../common/TitleBar.vue";
  import ComBox from "../../common/ComBox.vue";
  import TabBar from "../../common/TabBar.vue";
  import ComTable from "../../common/ComTable.vue";
  import { getAirData } from "@/api/air";
  import { formatValue } from "@/utils/pollutionLevel";
  import icon from "@/assets/dataScreen/icon-rank.png";
  export default {
    name: "AirRank",
    components: { TitleBar, ComBox, TabBar, ComTable },
    data() {
      return {
        icon,
        currentTab: 2,
        // 统计时间段(1=>分钟、2=>实时（当前小时数据）、3=>累计（当日截止到当前小时数据）、4=>昨日、5=>月、6=>年）
        tabList: [
          { label: "实时", value: 2 },
          { label: "累计", value: 3 },
          { label: "昨日", value: 4 },
          { label: "月", value: 5 },
          { label: "年", value: 6 },
        ],
        columns: [
          {
            prop: "index",
            label: "排名",
            width: "10%",
            slot: "index",
          },
          {
            prop: "site",
            label: "站点名称",
            width: "27%",
          },
          {
            prop: "complex_index",
            label: "综合指数",
            width: "20%"
          },
          {
            prop: "pm25",
            label: "PM2.5",
            width: "15%",
          },
          {
            prop: "pm10",
            label: "PM10",
            width: "15%",
          },
          {
            prop: "so2",
            label: "SO2",
            width: "12%",
          },
          {
            prop: "no2",
            label: "NO2",
            width: "12%",
          },
          {
            prop: "co",
            label: "CO",
            width: "12%",
          },
          {
            prop: "o3",
            label: "O3",
            width: "12%",
          },
        ],
        tableData: [],
      };
    },
    created() {
      this.getData();
    },
    mounted() {},
    methods: {
      getData() {
        getAirData({ time_type: this.currentTab }).then((res) => {
          const data = res.data || [];
          this.tableData = data.filter(row => {
            return row.site !== '师范学院' && row.site !== '廊坊十中'
          })
            .map((item) => {
              return {
                ...item,
                ...item.data,
                complex_index: formatValue(item.data.complex_index),
                pm25: formatValue(item.data.pm25),
                pm10: formatValue(item.data.pm10),
                so2: formatValue(item.data.so2),
                no2: formatValue(item.data.no2),
                co: formatValue(item.data.co),
                o3: formatValue(item.data.o3),
              };
            })
            .reverse()
        });
      },
    },
  };
</script>

<style scoped lang="less">
  .air-rank {
    width: 100%;
    height: auto;
    flex: 5;

    .table-wrapper {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 15px 0;
    }
  }
</style>
